//本地存储Token键值
const tokenKey = "beilie-user-token"
//本地缓存对象
const storage = window.localStorage
//token开启标志(token当前是否有效)，当某些页面的请求不需要token时设置为false
let tokenEnable = true;



export default {
    enable() {
        tokenEnable = true;
    },
    disable() {
        tokenEnable = false
    },
    /**
     * 禁用是否有效
     */
    isEnable() {
        return tokenEnable;
    },
    /**
     * @description 本地Token是否存在
     * @return boolean
     */
    hasToken() {
        return storage.getItem(tokenKey) != null
    },
    /**
     * @description 设置Token缓存
     * @param {string} value token值
     */
    setToken(value) {
        storage.setItem(tokenKey, value)
    },
    clearToken() {
        storage.removeItem(tokenKey)
    },
    /**
     * @description 获取token缓存
     * @return false|string
     */
    getToken() {
        if (this.hasToken()) {
            return storage.getItem(tokenKey)
        } else {
            return false;
        }
    },
}